/* eslint-disable @angular-eslint/no-host-metadata-property */
import { Directive, Input } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'img[src]',
    host: {
        '[src]': 'checkPath(src)',
        '(error)': 'onError()'
    }
})
export class DefaultImageDirective {
    @Input() src: string | undefined;
    public defaultImg = 'assets/images/placeholder.png';
    public onError() {
        this.src = this.defaultImg;
    }
    public checkPath(src: string) {
        return src ? src : this.defaultImg;
    }
}
